export const areas = [
  {
    slug: "salmiya",
    name: "السالمية",
    governorate: "حولي",
    description:
      "من أرقى المناطق السكنية في الكويت، تتميز بقربها من البحر والمراكز التجارية والمدارس الدولية.",
    longDescription:
      "تُعد السالمية وجهة مفضلة للعائلات والمغتربين بفضل بنيتها التحتية المتطورة، مطاعمها العالمية، وشواطئها الخلابة. توفر mix متنوع من الفيلات والشقق الفاخرة بإطلالات بحرية.",
    image: require("@/assets/media/4.png"),
    propertyCount: 124,
    avgPrice: 285000,
    highlights: ["قرب البحر", "مدارس دولية", "مراكز تسوق", "حياة ليلية"],
  },
  {
    slug: "hawally",
    name: "حولي",
    governorate: "حولي",
    description:
      "قلب الكويت النابض، يجمع بين الحيوية التجارية والراحة السكنية.",
    longDescription:
      "حولي مركز تجاري وسكني حيوي يضم مستشفيات مرموقة، جامعات، وأسواق تقليدية وحديثة. مناسبة للعائلات التي تبحث عن موقع مركزي.",
    image: require("@/assets/media/4.png"),
    propertyCount: 89,
    avgPrice: 220000,
    highlights: ["موقع مركزي", "مستشفيات", "مواصلات", "أسواق"],
  },
  {
    slug: "ahmadi",
    name: "الأحمدي",
    governorate: "الأحمدي",
    description:
      "منطقة هادئة وعائلية جنوب الكويت، مع فيلات واسعة ومجتمعات gated.",
    longDescription:
      "الأحمدي معروفة بفيلاتها الفسيحة، المساحات الخضراء، والهدوء. مناسبة للعائلات الكبيرة الباحثة عن الخصوصية ومساحات خارجية.",
    image: require("@/assets/media/Image2.png"),
    propertyCount: 76,
    avgPrice: 340000,
    highlights: ["هدوء", "فيلات واسعة", "مساحات خضراء", "مجتمعات مغلقة"],
  },
  {
    slug: "sharq",
    name: "الشرق",
    governorate: "العاصمة",
    description: "المركز المالي والتجاري، مكاتب فاخرة وشقق executive.",
    longDescription:
      "الشرق يضم أبراج الأعمال والفنادق الفاخرة. الخيار الأمثل للمحترفين والشركات الباحثة عن مكاتب وشقق في قلب المدينة.",
    image: require("@/assets/media/home.png"),
    propertyCount: 52,
    avgPrice: 195000,
    highlights: ["أبراج تجارية", "فنادق", "مكاتب", "موقع استراتيجي"],
  },
  {
    slug: "farwaniya",
    name: "الفروانية",
    governorate: "الفروانية",
    description: "منطقة سكنية متنوعة بأسعار تنافسية ومجمعات حديثة.",
    longDescription:
      "الفروانية توفر خيارات سكنية متنوعة للعائلات والشباب، مع مجمعات سكنية جديدة وخدمات متكاملة.",
    image: require("@/assets/media/8.png"),
    propertyCount: 98,
    avgPrice: 145000,
    highlights: ["أسعار تنافسية", "مجمعات جديدة", "أمن 24/7", "مواقف"],
  },
  {
    slug: "mubarak-al-kabeer",
    name: "مبارك الكبير",
    governorate: "مبارك الكبير",
    description: "منطقة نامية بأراضٍ سكنية وفرص استثمارية واعدة.",
    longDescription:
      "مبارك الكبير تشهد نمواً عقارياً ملحوظاً مع مشاريع سكنية جديدة وأراضٍ جاهزة للبناء في مواقع استراتيجية.",
    image: require("@/assets/media/9.png"),
    propertyCount: 61,
    avgPrice: 175000,
    highlights: ["أراضٍ سكنية", "استثمار", "نمو عقاري", "خدمات"],
  },
];

export function getAreaBySlug(slug) {
  return areas.find((a) => a.slug === slug);
}
